module.exports = __webpack_public_path__ + "img/call.225671e7.png";